import Head from 'next/head';
import React from 'react';
import {
	getCanonicalUrlForLocale,
	getCleanPath,
	getEffectiveHreflangLocales,
	isNonLocalizedPath,
} from '@/helpers';

interface HreflangTagsProps {
	currentPath: string;
	locales: readonly string[] | string[];
	defaultLocale: string;
	baseUrl: string;
}

/**
 * Generates hreflang tags only for locales that return 200 OK. Every href is a canonical URL for that locale.
 */
export const HreflangTags: React.FC<HreflangTagsProps> = ({
	currentPath,
	locales,
	defaultLocale,
	baseUrl,
}) => {
	const cleanPath = getCleanPath(currentPath, locales);
	const isNonLocalized = isNonLocalizedPath(cleanPath);
	const effectiveLocales = getEffectiveHreflangLocales(
		cleanPath,
		isNonLocalized,
		locales,
		defaultLocale,
	);

	const defaultLocaleUrl = getCanonicalUrlForLocale(
		baseUrl,
		cleanPath,
		defaultLocale,
		defaultLocale,
	);

	return (
		<Head>
			{effectiveLocales.map(locale => {
				const href = getCanonicalUrlForLocale(
					baseUrl,
					cleanPath,
					locale,
					defaultLocale,
				);
				return (
					<link key={locale} rel='alternate' hrefLang={locale} href={href} />
				);
			})}
			<link rel='alternate' hrefLang='x-default' href={defaultLocaleUrl} />
		</Head>
	);
};
